import { withDisplayName } from '@hocs/with-display-name'
import { EnhancedButton } from '@ui/enhanced-components/enhanced-components'
import {
  ENHANCED_COMPONENT_ROLE,
  ENHANCED_COMPONENT_TYPE,
} from '@ui/enhanced-components/types'
import { getPath } from '@utils/get-path'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulCtaNavbar: Utils.EntryFC<
  Queries.ContentfulCtaNavbarFragment
> = ({ content: { text, externalLink, internalLink } }) => {
  const href = getPath(internalLink) || externalLink || undefined

  return (
    <EnhancedButton
      className="!w-fit rounded-full !bg-[#8FD448] px-[20px] py-[10px] text-center text-075 font-medium !text-[#003500]"
      data-role={ENHANCED_COMPONENT_ROLE.STICKY_ACCESS}
      data-type={ENHANCED_COMPONENT_TYPE.CTA}
      href={href}
      id={ENHANCED_COMPONENT_ROLE.MAIN}
      size="small"
    >
      {text}
    </EnhancedButton>
  )
}

export const query = graphql`
  fragment ContentfulCtaNavbar on ContentfulCta {
    ...ContentfulEntry
    text
    internalLink {
      ...ContentfulBlogTagLink
      ...ContentfulBlogArticleLink
      ...ContentfulDeprecatedPageLink
      ...ContentfulStaticPageLink
    }
    externalLink
  }
`

export default withDisplayName(ContentfulCtaNavbar, 'ContentfulCtaNavbar')
